import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/mobileHeader';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import AlertBar from '../__header/AlertBar';
import PodcastButtonPlay from '../__utils/podcastButtonPlay';

const headerMobile = new MobileHeader();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		MegaMenu.init();
		headerMobile.init();
		Video.init();
		mirrorHover();
		smoothScroll();
		Tables.init();
		viewportUnits();
		AlertBar();
		PodcastButtonPlay();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		viewportUnits();
	},
	resized() {
		headerMobile.resized();
		Tables.toggleShadow();
		viewportUnits();
	},
	scrolled() {},
	keyDown() {},
	mouseUp(e) {
		headerMobile.hideOutsideClick(e);
	},
};
export default controller;
